var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackageIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 6.27771L9.99997 10.9999M9.99997 10.9999L1.49997 6.27771M9.99997 10.9999L10 20.5M19 15.0585V6.94141C19 6.59876 19 6.42744 18.9495 6.27464C18.9049 6.13947 18.8318 6.01539 18.7354 5.9107C18.6263 5.79236 18.4766 5.70916 18.177 5.54276L10.777 1.43164C10.4934 1.27409 10.3516 1.19531 10.2015 1.16442C10.0685 1.13709 9.93146 1.13709 9.79855 1.16442C9.64838 1.19531 9.50658 1.27409 9.22297 1.43165L1.82297 5.54276C1.52345 5.70916 1.37369 5.79236 1.26463 5.9107C1.16816 6.01539 1.09515 6.13947 1.05048 6.27465C1 6.42745 1 6.59877 1 6.94141V15.0585C1 15.4012 1 15.5725 1.05048 15.7253C1.09515 15.8605 1.16816 15.9845 1.26463 16.0892C1.37369 16.2076 1.52345 16.2908 1.82297 16.4572L9.22297 20.5683C9.50658 20.7258 9.64838 20.8046 9.79855 20.8355C9.93146 20.8628 10.0685 20.8628 10.2015 20.8355C10.3516 20.8046 10.4934 20.7258 10.777 20.5683L18.177 16.4572C18.4766 16.2908 18.6263 16.2076 18.7354 16.0892C18.8318 15.9845 18.9049 15.8605 18.9495 15.7253C19 15.5725 19 15.4012 19 15.0585Z",
    stroke: "#1746E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageIc);
export default __webpack_public_path__ + "static/media/package-ic.cd0b44e155751de3b107c06c67f529ed.svg";
export { ForwardRef as ReactComponent };